/**
 * Return a string with the count and item name, pluralized if necessary:
 * e.g. `"1 package"`, `"2 packages"`.
 *
 * Use `pluralWords()` if you only want the item name.
 *
 * @param count - The number of items
 * @param item - The singular item name. Include `$s` to put the 's' in a different spot
 * (if `pluralItem` is not provided).
 * @param pluralItem - The plural item name (defaults to `${item}s`)
 */
export function plural(count: number, item: string, pluralItem?: string): string {
  return `${count} ${pluralWords(count, item, pluralItem)}`;
}

/**
 * Return a string with the item name (NOT `count`), pluralized if necessary:
 * e.g. `"package"`, `"packages"`.
 *
 * Use `plural()` if you also want the count in the string.
 *
 * @param count - The number of items
 * @param item - The singular item name. Include `$s` to put the 's' in a different spot
 * (if `pluralItem` is not provided).
 * @param pluralItem - The plural item name (defaults to `${item}s`)
 */
export function pluralWords(count: number, item: string, pluralItem?: string): string {
  if (count === 1) {
    return item.replace('$s', '');
  }
  if (pluralItem) {
    return pluralItem;
  }
  return item.includes('$s') ? item.replace('$s', 's') : item + 's';
}
